import { mapLoyaltyEducation } from 'stores/adapters/bex-api/search/loyalty-education-adapter';
import { mapPropertySearchMessage, SearchMigrationAdapter } from 'stores/adapters';

import { HotelResultsViewModel } from 'models';

import { FullPropertySearch, OperationResult, PropertyMapMigration } from '__generated__/api';

export const adaptInsights: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<FullPropertySearch.Query> | OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.summary) {
    return bffResults;
  }

  return {
    ...bffResults,
    loyaltyEducation: mapLoyaltyEducation(propertySearch.summary),
    messages: mapPropertySearchMessage(propertySearch.summary)
  };
};
